export const formatCurrency = (value?: number | null, maximumFractionDigits: number = 2) => {
    if (value === null || value === undefined) {
        return "-";
    }

    return value.toLocaleString(undefined, { style: "currency", currency: "AUD", maximumFractionDigits: maximumFractionDigits });
};

export const formatPercentage = (value?: number | null): string => {
    if (value === null || value === undefined) {
        return "-";
    }

    return value.toLocaleString(undefined, { style: "percent", maximumFractionDigits: 0 });
};

export const formatNumber = (value?: number | null): string => {
    if (value === null || value === undefined) {
        return "-";
    }

    return value.toLocaleString(undefined, { maximumFractionDigits: 0 });
};

export const isDefinedNumber = (value: number | null | undefined): value is number => {
    return value !== null && value !== undefined;
};

export const toNullableNumberValue = (value: unknown): number | null => typeof value === "number" ? value : null;

export const toNumberValue = (value: unknown): number => typeof value === "number" ? value : 0;
